import { headerActions } from '@/store/header'
import pubhubData from '@/utils/apiHelpers/pubhubData'
import { GetImageByConfig } from '@/utils/productHelper'

/**
 * Sets the header model data with product image (Server-side or with store)
 * @param {Object} store - Redux store
 * @param {Object} modelData - Model data object
 * @param {string} modelData.brand - Brand name
 * @param {string} modelData.model - Model name
 * @param {string} modelData.modelType - Model type
 * @param {string} modelData.year - Year
 * @param {string} modelData.language - Language
 * @returns {Promise<Object>} Returns { image, productImages }
 */
export const setHeaderModel = async (store, modelData) => {
  const { brand, model, modelType, year, language } = modelData

  // Get product images and find the matching image
  const productImages = await pubhubData.getProductsImages()
  const image = GetImageByConfig(productImages, model, modelType, year) || null

  // Dispatch to store
  store.dispatch(
    headerActions.SET_MODEL({
      brand,
      model,
      modelType,
      year,
      language,
      image
    })
  )

  return { image, productImages }
}

/**
 * Sets the header model data with product image (Client-side with dispatch)
 * @param {Function} dispatch - Redux dispatch function
 * @param {Object} modelData - Model data object
 * @param {string} modelData.brand - Brand name
 * @param {string} modelData.model - Model name
 * @param {string} modelData.modelType - Model type
 * @param {string} modelData.year - Year
 * @param {string} modelData.language - Language
 * @param {string} [modelData.cachedImageUrl] - Cached image URL (for offline use)
 * @returns {Promise<Object>} Returns { image, productImages }
 */
export const setHeaderModelClient = async (dispatch, modelData) => {
  const { brand, model, modelType, year, language, cachedImageUrl } = modelData

  let image = cachedImageUrl || null
  let productImages = []

  // Try to get product images from API (will fail when offline)
  try {
    productImages = await pubhubData.getProductsImages()
    image = GetImageByConfig(productImages, model, modelType, year) || cachedImageUrl || null
  } catch {
    // Use cached image if API fails (offline mode)
    image = cachedImageUrl || null
  }

  // Dispatch to store
  dispatch(
    headerActions.SET_MODEL({
      brand,
      model,
      modelType,
      year,
      language,
      image
    })
  )

  return { image, productImages }
}

const headerHelper = {
  setHeaderModel,
  setHeaderModelClient
}

export default headerHelper
